import { Component } from "react";

export class OpsLeadsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      // {
      //   name: "productType",
      //   label: "Product Type",
      //   type: "select",
      //   options: [],
      //   placeholder: "Product Type",
      // },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS,
        placeholder: "Status",
      },
    ];
    this.isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  }

  componentDidMount() {
    // this.getProductTypes();
  }

  getProductTypes() {
    this.props.apis.apiGetProductTypes().then((res) => {
      let productType = this.fields.find((o) => o.name == "productType");
      productType.options = res;
    });
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <>
        <div className="d-flex align-items-center justify-content-end py-3 pe-3">
          <button
            type="button"
            className="btn filter_modal_btn"
            onClick={(...args) => this.toggleDrawer(...args)}
          >
            <i class="fa-solid fa-filter me-2"></i>
            <span>Filters</span>
          </button>
        </div>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </>
    );
  }
}

export default constore(OpsLeadsSearch);
